import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = { data: null, processing: false, isSuccess: null };

const saveCourseSlice = createSlice({
  name: "saveCourse",
  initialState,
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
      state.data = action.payload.courseId;
      state.isSuccess = null;
    },
    success(state) {
      state.processing = false;
      state.isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.isSuccess = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    clear() {
      return initialState;
    },
  },
});

const { name, actions, reducer } = saveCourseSlice;
const saveCourseAction = createAction(name);

export {
  saveCourseAction,
  actions as saveCourseActions,
  reducer as saveCourseReducer,
};
